import "./App.css";
import Basic from "./components/Basic";
import EveChatUI from "./components/EVEchatui";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import EveChat from "./components/EveChat";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    const handleClick = (event) => {
      const tag = event.target.tagName;
      const className = event.target.className;

      console.log("Clicked element:", event.target);

      // 1️⃣ Existing required message for your current website logic
      window.parent.postMessage(
        {
          type: "iframe-click",
          tag,
          className,
        },
        "*"
      );

      // 2️⃣ Detect chatbot open/close events (X button & robot button)
      if (className.includes("chatbot-fixed") || tag === "IMG") {
        // Chat icon clicked → expand iframe
        window.parent.postMessage(
          {
            type: "chatbot-toggle",
            open: true,
            height: "600px",
          },
          "*"
        );
      }

      if (tag === "A" || className.includes("close-chat")) {
        // Close button clicked → collapse iframe
        window.parent.postMessage(
          {
            type: "chatbot-toggle",
            open: false,
            height: "80px",
          },
          "*"
        );
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/chat" element={<EveChat embedMode={true} />} />
          <Route path="/" element={<EveChatUI />} /> {/* Chatbot-only route */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
// rasa run --enable-api --cors "*" --port 5010

// # genai.configure(api_key="AIzaSyDfPCgUcAaahis5nFMd3yZJA_HVaXwt4Aw")
// genai.configure(api_key="AIzaSyB3YRoFlvD3nCTFutWl7YcJxGsf4HIWpVc")
